$(document).ready(function () {
    get_address_info();
    $('input[type="date"]').each(function () {
        const today = new Date().toLocaleDateString('af-ZA');
        $(this).attr('max', today);
    });
    $('#place').on('change', () => {
        const place_val = $('#place').val();
        $('.op_tick').val(null);
        $('.op_tick').removeClass('filled');
        if (place_val !== 'Página web') {
            $('#web').fadeOut();
            setTimeout(() => {
                $('#ticket_photo').removeClass('hide');
                $('#ticket_photo').fadeIn();
                $('#ticket').attr('required', true);
                $('#tda').fadeIn();
            }, 300);
            $('.op_tick').removeAttr('required');
            $('#estacion').attr('required', true);
            $('#folio').attr('required', true);
            $('#typ_paym').html(`
                <option value="" disabled selected>Forma de pago*</option>
                <option value="Cheque nominativo">Cheque nominativo</option>
                <option value="Efectivo">Efectivo</option>
                <option value="Tarjeta de crédito">Tarjeta de crédito</option>
                <option value="Tarjeta de débito">Tarjeta de débito</option>
                <option value="Transferencia">Transferencia</option>
            `);
        } else {
            $('#ticket_photo').fadeOut();
            $('#ticket').removeAttr('required');
            $('#tda').fadeOut();
            setTimeout(() => {
                $('#web').fadeIn();
            }, 300);
            $('.op_tick').removeAttr('required');
            $('#buy_day').attr('required', true);
            $('#no_pedido').attr('required', true);

            $('#typ_paym').html(`
                <option value="" disabled selected>Forma de pago*</option>
                <option value="Depósito">Depósito</option>
                <option value="Transferencia">Transferencia</option>
                <option value="Tarjeta de crédito">Tarjeta de crédito</option>
                <option value="Tarjeta de débito">Tarjeta de débito</option>
            `);
        }
        setTimeout(() => {
            $('#type_payment').fadeIn(500);
            $('#nxt-1').fadeIn(700);
        }, 400);
    });
    $('#persona').on('change', () => {
        const persona_val = $('#persona').val();
        $('#last_name').val(null);
        $('#regimen').removeClass('filled');
        $('#CFDI').removeClass('filled');
        if (persona_val === 'Persona física') {
            $('.op_fisc').attr('required', true);

            $('#last_name').removeClass('hide');
            $('#last_name').fadeIn();

            $('#fisc_data').fadeIn();

            $('#regimen').html(`
                <option value="" disabled selected>Régimen fiscal*</option>
                <option value="Régimen de Actividades Empresariales y Profesionales">Régimen de Actividades Empresariales y Profesionales</option>
                <option value="Régimen de Arrendamiento">Régimen de Arrendamiento</option>
                <option value="Régimen de Confianza">Régimen de Confianza</option>               
                <option value="Régimen de Incorporación Fiscal">Régimen de Incorporación Fiscal</option>
                <option value="Régimen de Incorporación Fiscal"> Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas</option>
            `);

            $('#CFDI').html(`
                <option value="" disabled selected>Uso de CFDI*</option>
                <option value="Adquisición de mercancías">Adquisición de mercancías</option>
                <option value="Aportaciones voluntarias al SAR">Aportaciones voluntarias al SAR</option>
                <option value="Comunicaciones telefónicas">Comunicaciones telefónicas</option>
                <option value="Comunicaciones satelitales">Comunicaciones satelitales</option>
                <option value="Construcciones">Construcciones</option>
                <option value="Dados, troqueles, moldes, matrices y herramental">Dados, troqueles, moldes, matrices y herramental</option>
                <option value="Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones">Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones</option>
                <option value="Devoluciones, descuentos o bonificaciones">Devoluciones, descuentos o bonificaciones</option>
                <option value="Donativos">Donativos</option>
                <option value="Equipo de cómputo y accesorios">Equipo de cómputo y accesorios</option>
                <option value="Equipo de transporte">Equipo de transporte</option>
                <option value="Gastos en general">Gastos en general</option>
                <option value="Gastos de transportación escolar obligatoria">Gastos de transportación escolar obligatoria</option>
                <option value="Gastos funerales">Gastos funerales</option>
                <option value="Gastos médicos por incapacidad o discapacidad">Gastos médicos por incapacidad o discapacidad</option>
                <option value="Honorarios médicos, dentales y gastos hospitalarios">Honorarios médicos, dentales y gastos hospitalarios</option>
                <option value="Intereses reales efectivamente pagados por créditos hipotecarios (Casa habitación)">Intereses reales efectivamente pagados por créditos hipotecarios (Casa habitación)</option>
                <option value="Mobiliario y equipo de oficina por inversiones">Mobiliario y equipo de oficina por inversiones</option>
                <option value="Otra maquinaria y equipo">Otra maquinaria y equipo</option>
                <option value="Pagos por servicios educativos (colegiaturas)">Pagos por servicios educativos (colegiaturas)</option>
                <option value="Primas por seguros de gastos médicos">Primas por seguros de gastos médicos</option>
                <option value="Por definir">Por definir</option>
            `);
        } else {
            $('.op_fisc').removeAttr('required');
            $('#last_name').fadeOut();

            $('#regimen').html(`
                <option value="" disabled selected>Régimen fiscal*</option>
                <option value="Régimen de Pequeñas Empresas">Régimen de Pequeñas Empresas</option>                
                <option value="Régimen General de Ley para Personas Morales">Régimen General de Ley para Personas Morales</option>
            `);

            $('#CFDI').html(`
                <option value="" disabled selected>Uso de CFDI*</option>
                <option value="Adquisición de mercancías">Adquisición de mercancías</option>
                <option value="Comunicaciones telefónicas">Comunicaciones telefónicas</option>
                <option value="Comunicaciones satelitales">Comunicaciones satelitales</option>
                <option value="Construcciones">Construcciones</option>
                <option value="Dados, troqueles, moldes, matrices y herramental">Dados, troqueles, moldes, matrices y herramental</option>
                <option value="Devoluciones, descuentos o bonificaciones">Devoluciones, descuentos o bonificaciones</option>
                <option value="Equipo de transporte">Equipo de transporte</option>
                <option value="Equipo de cómputo y accesorios">Equipo de cómputo y accesorios</option>
                <option value="Gastos en general">Gastos en general</option>
                <option value="Mobiliario y equipo de oficina por inversiones">Mobiliario y equipo de oficina por inversiones</option>
                <option value="Otra maquinaria y equipo">Otra maquinaria y equipo</option>
                <option value="Por definir">Por definir</option>
            `);
            setTimeout(() => {
                $('#last_name').addClass('hide');
            }, 300);
            $('#fisc_data').fadeIn();

        }
    });
    $('.input-data select').change(function (e) {
        $(this).removeClass('empty_input');
        ($(this).val() !== '' && $(this).val() !== null)
            && $(this).addClass('filled');
    });
    $('#constancia').change(function () {
        console.log($(this).val());
        ($(this).val() !== null && $(this).val() !== '')
            ? $($(this).prev()).addClass('filled')
            : $($(this).prev()).removeClass('filled');
    });

    $('#ticket').change(function () {
        console.log($(this).val());
        ($(this).val() !== null && $(this).val() !== '')
            ? $($(this).prev()).addClass('filled')
            : $($(this).prev()).removeClass('filled');
    });
    $('.input-data textarea').change(function (e) {
        $(this).removeClass('empty_input');
    });
    $('.input-data input').change(function (e) {
        $(this).removeClass('empty_input');
        if ($(this).val().length > 0) {
            $(this).addClass('filled');
        } else {
            $(this).removeClass('filled');
        }
    });

    $('#state').change(function () {
        const state = $('#state').val();
        $('#municipality').attr('disabled');
        get_address_info(state);
    });
});

const nxt_screen = (screen) => {
    switch (screen) {
        case 1:
            validate_inputs('place_card');
            break;
        case 2:
            validate_inputs('phisc_card');
            break;
        case 3:
            validate_inputs('personal_card');
            break;
        default:
            break;
    }

}

const validate_inputs = (id) => {
    let data_fill = $(`#${id} [required="required"]`);
    let bnd = true;
    let indx = 0;

    for (let i = 0; i < data_fill.length; i++) {
        if ($(data_fill[i]).val() === '' || $(data_fill[i]).val() === null) {
            bnd = false;
            indx = i;
            break;
        }
    }
    if (bnd) {
        if (id !== 'personal_card') {
            next_content();
        } else {
            showLoader('#loaderFormFactura');
            $('#submit_form').attr('disabled', 'true');
            const place = $('#place').val().trim();
            let order = "";
            (place !== 'Página web')
                ? order = $('#estacion').val().trim() + '-' + $('#folio').val().trim()
                : order = $('#no_pedido').val().trim();

            const date_buy = $('#buy_day').val().trim();
            const type_payment = $('#typ_paym').val().trim();//
            const persona = $('#persona').val().trim();
            const rfc = $('#rfc').val().trim();
            const nombre = $('#nombre').val().trim();
            const ap_pat = $('#ap_pat').val().trim();
            const ap_mat = $('#ap_mat').val().trim();
            const nom_fisc = $('#nom_fisc').val().trim();
            const regimen_fis = $('#regimen').val().trim();
            const uso_cfdi = $('#CFDI').val().trim();
            const constancia = $('#constancia').prop('files')[0];
            const state = $('#state').val().trim();
            const municipality = $('#municipality').val().trim();
            const cp = $('#cp').val().trim();
            const colonia = $('#colonia').val().trim();
            const calle = $('#calle').val().trim();
            const no_ext = $('#no_ext').val().trim();
            const no_int = $('#no_int').val().trim();
            const phone = $('#phone').val().trim();
            const email = $('#email').val().trim();
            const ticket = $('#ticket').prop('files')[0];

            let formData = new FormData();
            formData.append('place', place);
            formData.append('order', order);
            formData.append('date_buy', date_buy);
            formData.append('type_payment', type_payment);
            formData.append('persona', persona);
            formData.append('rfc', rfc);
            formData.append('nombre', nombre);
            formData.append('ap_pat', ap_pat);
            formData.append('ap_mat', ap_mat);
            formData.append('nom_fisc', nom_fisc);
            formData.append('regimen_fis', regimen_fis);
            formData.append('uso_cfdi', uso_cfdi);
            formData.append('constancia', constancia);
            formData.append('fPName', `${rfc}-${order}-constancia`);
            formData.append('state', state);
            formData.append('municipality', municipality);
            formData.append('cp', cp);
            formData.append('colonia', colonia);
            formData.append('calle', calle);
            formData.append('no_ext', no_ext);
            formData.append('no_int', no_int);
            formData.append('phone', phone);
            formData.append('email', email);
            formData.append('ticket', ticket);
            formData.append('fPTicket', `${rfc}-${order}-ticket`);

            const bodyE = `
                <ul>
                    <li><strong>Lugar de la compra: </strong> ${place} </li>
                    <li><strong>${(place === 'Página web') ? "Pedido" : "Ticket"}: </strong> ${order} </li>
                    ${(place === 'Página web') ? "<li><strong>Fecha de la compra: </strong> " + date_buy + " </li>" : ""}
                    <li><strong>Tipo de pago: </strong> ${type_payment} </li>
                    <li><strong>Tipo de persona: </strong> ${persona} </li>
                    <li><strong>RFC: </strong> ${rfc} </li>
                    <li><strong>Nombre: </strong> ${nombre} </li>
                    ${(persona === 'Persona física') ? "<li><strong>Apellido paterno: </strong> " + ap_pat + " </li>" : ""}
                    ${(persona === 'Persona física') ? "<li><strong>Apellido materno: </strong> " + ap_mat + " </li>" : ""}
                    <li><strong>Nombre fiscal: </strong> ${nom_fisc} </li>
                    <li><strong>Régimen fiscal: </strong> ${regimen_fis} </li>
                    <li><strong>Uso de CFDI: </strong> ${uso_cfdi} </li>
                    <li><strong>Estado: </strong> ${nom_fisc} </li>
                    <li><strong>Municipio: </strong> ${municipality} </li>
                    <li><strong>CP: </strong> ${cp} </li>
                    <li><strong>Colonia: </strong> ${colonia} </li>
                    <li><strong>Calle: </strong> ${calle} </li>
                    <li><strong>No. exterior: </strong> ${no_ext} </li>
                    <li><strong>No. interior: </strong> ${no_int} </li>
                    <li><strong>Teléfono: </strong> ${phone} </li>
                    <li><strong>Correo electrónico: </strong> ${email} </li>
                </ul>
            `;

            const content = `
                <div class="mailBody">
                    <div class="cardMail">
                        <center><img class="" style="margin-bottom: 20px; width:250px;" src="https://cdn.shopify.com/s/files/1/1292/2935/files/LOGO_cantia_change.png?v=1643318474"/></center>
                        <div class="container">
                            <h1 class="title">Solicitud de factura</h1>
                            <p>Se solicita una factura con la siguiente información: </p>
                            ${bodyE}
                        </div>
                    </div>
                </div>
            `;

            formData.append('content', content);

            $.ajax({
                url: 'https://sendermail-dot-mx-vianney-001.uc.r.appspot.com/admin/facturacion/send_data.php',
                method: 'POST',
                data: formData,
                contentType: false,
                cache: false,
                processData: false,
                headers: {
                    "accept": "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                error: function (request, error) {
                    console.error(arguments);
                    console.error(" Can't do because: " + error);
                },
                success: function (res) {
                    if (isJson(res)) {
                        res = $.parseJSON(res);
                        console.log(res);
                        if (res.insert === 1) {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 2000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener('mouseenter', Swal.stopTimer)
                                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                                }
                            })

                            Toast.fire({
                                icon: 'success',
                                title: 'Datos envíados'
                            });
                            setTimeout(() => {
                                location.reload();
                            }, 2000);
                        } else if (res.res.includes('Esta factura con el pedido')) {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 2000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener('mouseenter', Swal.stopTimer)
                                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                                }
                            })

                            Toast.fire({
                                icon: 'warning',
                                title: res.res
                            });


                        }
                    } else {
                        console.warn(res);
                    }
                },
                complete: function () {
                    $('#municipality').removeAttr('disabled');
                    hideLoader('#loaderFormFactura');
                    $('#submit_form').removeAttr('disabled');
                }
            });
        }
    } else {
        for (let i = 0; i < data_fill.length; i++) {
            if ($(data_fill[i]).val() === '' || $(data_fill[i]).val() === null) {
                (data_fill[i].id === 'constancia') && $('#fisc_data .text-inp-file').addClass('empty_input');
                if ($(data_fill[i]).is(':visible')) {
                    $(data_fill[i]).addClass('empty_input');
                }
            }
        }
        Swal.fire({
            title: `Campos obligatorios vacios`,
            icon: 'error',
            html: '<p>Llena los campos que tengan un "*"</p>',
        }).then((result) => {
            if (result.isConfirmed) {
                setTimeout(() => {
                    $(data_fill[indx]).trigger("focus");
                }, 400);
            }
        })
    }
}


const prev_content = () => {
    const active_bullet = $('.bullet.active');
    const active_card = $('.card.active');
    const prev_bullet = $(active_bullet).prev();
    const prev_card = $(active_card).prev();
    if (prev_bullet.length > 0) {
        $(active_bullet).removeClass('previous_active');
        $(active_bullet).removeClass('active');
        $(active_card).removeClass('animate__fadeInRight');
        $(active_card).addClass('animate__fadeOutRight');

        $(prev_bullet).addClass('active');
        setTimeout(() => {
            $(active_card).removeClass('active');

            $(prev_card).removeClass('animate__fadeInRight animate__fadeOutLeft');
            $(prev_card).addClass('active animate__fadeInLeft');
        }, 470);
    }
}
const next_content = () => {
    const active_bullet = $('.bullet.active');
    const active_card = $('.card.active');
    const next_bullet = $(active_bullet).next();
    const next_card = $(active_card).next();
    if (next_bullet.length > 0) {
        $(active_bullet).addClass('previous_active');
        $(active_bullet).removeClass('active');
        $(active_card).removeClass('animate__fadeOutRight');
        $(active_card).addClass('animate__fadeOutLeft');

        $(next_bullet).addClass('active');
        setTimeout(() => {
            $(active_card).removeClass('active');

            $(next_card).removeClass('animate__fadeOutRight');
            $(next_card).addClass('active animate__fadeInRight');
        }, 470);
    }

}

const swa_img = () => {
    const place = $('#place').val();
    Swal.fire({
        title: `¿Donde encuentro la estación y el folio en mi ticket en ${place}?`,
        html: `
                <div class="content-tickets">
                    <div class="d-flex gap-1 flex-column">
                        <p class="text-center">Estación</p>
                        <img width="265" src="https://cdn.shopify.com/s/files/1/1292/2935/files/ticket_foraneo_estacion.jpg?v=1699480838">
                    </div>
                    <div class="d-flex gap-1 flex-column">
                        <p class="text-center">Folio</p>                    
                        <img width="265" src="https://cdn.shopify.com/s/files/1/1292/2935/files/ticket_foraneo_folio.jpg?v=1699480838">
                    </div>
                </div>  
            `,
        customClass: {
            title: 'title_alert',
            popup: 'images-tickets'
        },
        showConfirmButton: false,
        showCloseButton: true
    })
}



$('.numberonly').keypress(function (e) {
    let charCode = (e.which) ? e.which : event.keyCode
    if (String.fromCharCode(charCode).match(/[^0-9]/g))
        return false;
});

const get_address_info = (state = "") => {
    let formData = new FormData();

    if (state === "") {
        formData.append('state', 'default');
        $.ajax({
            url: 'https://sendermail-dot-mx-vianney-001.uc.r.appspot.com/admin/states/address.php',
            method: 'POST',
            data: formData,
            contentType: false,
            cache: false,
            processData: false,
            headers: {
                "accept": "application/json",
                "Access-Control-Allow-Origin": "*"
            },
            error: function (request, error) {
                console.error(arguments);
                console.error(" Can't do because: " + error);
            },
            success: function (res) {
                if (isJson(res)) {
                    res = $.parseJSON(res);
                    console.log(res);
                    res.states.forEach(state => {
                        $('#state').append(`
                            <option value="${state.vcha_c_estado}">${state.vcha_nombre}</option>
                        `);
                    });
                } else {
                    console.warn(res);
                }
            },
            complete: function () {
                $('#municipality').removeAttr('disabled');
            }
        });
    } else {
        formData.append('state', state);
        $.ajax({
            url: 'https://sendermail-dot-mx-vianney-001.uc.r.appspot.com/admin/states/address.php',
            method: 'POST',
            data: formData,
            contentType: false,
            cache: false,
            processData: false,
            headers: {
                "accept": "application/json",
                "Access-Control-Allow-Origin": "*"
            },
            error: function (request, error) {
                console.error(arguments);
                console.error(" Can't do because: " + error);
            },
            success: function (res) {
                if (isJson(res)) {
                    res = $.parseJSON(res);
                    console.log(res);
                    $('#municipality').removeAttr('disabled');
                    $('#municipality').html(`
                        <option value="" disabled selected>Municipio*</option>
                    `);
                    res.municipalities.forEach(municipality => {
                        $('#municipality').append(`
                            <option value="${municipality.name}">${municipality.name}</option>
                        `);
                    });
                } else {
                    console.warn(res);
                }
            },
            complete: function () {
                $('#municipality').removeAttr('disabled');


            }
        });
    }
}
